import { PaperPlaneRight } from '@phosphor-icons/react';

export default PaperPlaneRight;